import React from "react";
import "./ShareCampaign.css";
import {
  Button,
  Form,
  message,
  Modal,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingInput from "../../common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { shareCampaignDetails } from "../../../store/thunks/buyer-thunks/BuyerThunks";
const { Text } = Typography;
const ShareCampaign = ({ shareCampaign, setShareCampaign, campaignId }) => {
  const dispatch = useDispatch();
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const { isLoading, shareCampaignResponse } = useSelector(
    (state) => state?.buyerCampaigns
  );
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = React.useState(false);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const handleSendCampaign = (e) => {
    let payload = {
      ...e,
      campaign_id: campaignId,
    };
    dispatch(shareCampaignDetails(payload))
      .then((res) => {
        if (res?.payload?.status == 1) {
          message.success(
            res?.payload?.message || "Campaign shared successfully!"
          );
          form.resetFields();
          setShareCampaign(false);
        } else {
          message.error(
            res?.payload?.message?.join(",") ||
              "Something went wrong ,please try again."
          );
        }
      })
      .catch((error) => {
        message.error("Failed to share the campaign. Please try again!");
        console.error(error);
      });
  };

  const handleFormChange = () => {
    const fields = form.getFieldsValue();
    const emailErrors = form.getFieldError("email");
    const nameErrors = form.getFieldError("receiver_name");
    const isValid =
      fields.receiver_name &&
      fields.receiver_name.trim() !== "" &&
      fields.email &&
      fields.email.trim() !== "" &&
      emailErrors.length === 0 &&
      nameErrors.length === 0;
    setIsFormValid(isValid);
  };

  return (
    <>
      <div>
        <Row>
          <Text className="share-camapign-model-header">
            Share Your Campaign with Ease!
          </Text>
        </Row>
        <Form
          onFinish={handleSendCampaign}
          form={form}
          onValuesChange={handleFormChange}
        >
          <Form.Item
            name="receiver_name"
            rules={[
              {
                required: true,
                message: "Recipient's Name is required!",
              },
            ]}
          >
            <Row>
              <FloatingInput
                className="billboard-input-feild"
                label={
                  <>
                    {`Recipient's Name `}
                    {star}
                  </>
                }
                customStyles={floatingInputStyles}
              />
            </Row>
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Email is required!",
              },
            ]}
          >
            <Row>
              <FloatingInput
                className="billboard-input-feild"
                label={
                  <>
                    {`Recipient's Email `}
                    {star}
                  </>
                }
                customStyles={floatingInputStyles}
              />
            </Row>
          </Form.Item>

          <Row justify="end" style={{ gap: "0.5rem" }}>
            <Button
              className="billboard-buttons billboard-button-1"
              onClick={(e) => {
                setShareCampaign(false);
                form.resetFields();
                setIsFormValid(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className={`billboard-buttons billboard-button-2 ${
                !isFormValid ? "disabled-opacity" : ""
              }`}
              disabled={!isFormValid}
              htmlType="submit"
            >
              Send Campaign
            </Button>
          </Row>
        </Form>
        <Row>
          <Text className="need-help-text">
            Need help?{" "}
            <a
              className="campaign-support-link"
              href="/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact support
            </a>{" "}
            if you're having trouble sharing your campaign.
          </Text>
        </Row>
      </div>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default ShareCampaign;
